export type PaymentCurrency = (typeof PAYMENT_CURRENCIES)[number];

export function isPaymentCurrency(value?: string): value is PaymentCurrency {
  if (!value) {
    return false;
  }

  return PAYMENT_CURRENCIES.includes(value as PaymentCurrency);
}

export function canBeCastToPaymentCurrency(value?: string) {
  if (!value) {
    return false;
  }

  const currencyCandidate = value.trim().substring(0, 3).toUpperCase();

  return isPaymentCurrency(currencyCandidate);
}

export function toPaymentCurrency(rawCurrency: string) {
  const currencyCandidate = rawCurrency.trim().substring(0, 3).toUpperCase();

  if (isPaymentCurrency(currencyCandidate)) {
    return currencyCandidate;
  }

  throw new Error(`Unsupported payment currency: ${rawCurrency}`);
}

export type ZeroDecimalCurrency = (typeof ZERO_DECIMAL_CURRENCIES)[number];

export function isZeroDecimalCurrency(
  value: string
): value is ZeroDecimalCurrency {
  return ZERO_DECIMAL_CURRENCIES.includes(value as ZeroDecimalCurrency);
}

export const SpecialZeroDecimalCurrencies = [
  'ISK',
  'HUF',
  'TWD',
  'UGX'
] as const;

export type SpecialZeroDecimalCurrency =
  (typeof SpecialZeroDecimalCurrencies)[number];

export function isSpecialZeroDecimalCurrency(
  value: string
): value is SpecialZeroDecimalCurrency {
  return SpecialZeroDecimalCurrencies.includes(
    value as SpecialZeroDecimalCurrency
  );
}

export type MinAmountCurrency = (typeof MIN_AMOUNT_CURRENCIES)[number];

export function isMinAmountCurrency(value: string): value is MinAmountCurrency {
  return MIN_AMOUNT_CURRENCIES.includes(value as MinAmountCurrency);
}

export type MaxAmountCurrency = (typeof MAX_AMOUNT_CURRENCIES)[number];

export function isMaxAmountCurrency(value: string): value is MaxAmountCurrency {
  return MAX_AMOUNT_CURRENCIES.includes(value as MaxAmountCurrency);
}

export const PAYMENT_CURRENCIES = [
  'AED',
  'AFN',
  'ALL',
  'AMD',
  'ANG',
  'AOA',
  'ARS',
  'AUD',
  'AWG',
  'AZN',
  'BAM',
  'BBD',
  'BDT',
  'BGN',
  'BIF',
  'BMD',
  'BND',
  'BOB',
  'BRL',
  'BSD',
  'BWP',
  'BYN',
  'BZD',
  'CAD',
  'CDF',
  'CHF',
  'CLP',
  'CNY',
  'COP',
  'CRC',
  'CVE',
  'CZK',
  'DJF',
  'DKK',
  'DOP',
  'DZD',
  'EGP',
  'ETB',
  'EUR',
  'FJD',
  'FKP',
  'GBP',
  'GEL',
  'GIP',
  'GMD',
  'GNF',
  'GTQ',
  'GYD',
  'HKD',
  'HNL',
  'HTG',
  'HUF',
  'IDR',
  'ILS',
  'INR',
  'ISK',
  'JMD',
  'JPY',
  'KES',
  'KGS',
  'KHR',
  'KMF',
  'KRW',
  'KYD',
  'KZT',
  'LAK',
  'LBP',
  'LKR',
  'LRD',
  'LSL',
  'MAD',
  'MDL',
  'MGA',
  'MKD',
  'MMK',
  'MNT',
  'MOP',
  'MUR',
  'MVR',
  'MWK',
  'MXN',
  'MYR',
  'MZN',
  'NAD',
  'NGN',
  'NIO',
  'NOK',
  'NPR',
  'NZD',
  'PAB',
  'PEN',
  'PGK',
  'PHP',
  'PKR',
  'PLN',
  'PYG',
  'QAR',
  'RON',
  'RSD',
  'RUB',
  'RWF',
  'SAR',
  'SBD',
  'SCR',
  'SEK',
  'SGD',
  'SHP',
  'SLE',
  'SOS',
  'SRD',
  'STD',
  'SZL',
  'THB',
  'TJS',
  'TOP',
  'TRY',
  'TTD',
  'TWD',
  'TZS',
  'UAH',
  'UGX',
  'USD',
  'UYU',
  'UZS',
  'VND',
  'VUV',
  'WST',
  'XAF',
  'XCD',
  'XCG',
  'XOF',
  'XPF',
  'YER',
  'ZAR',
  'ZMW'
] as const;

export const ZERO_DECIMAL_CURRENCIES = [
  'BIF',
  'CLP',
  'DJF',
  'GNF',
  'JPY',
  'KMF',
  'KRW',
  'MGA',
  'PYG',
  'RWF',
  'VND',
  'VUV',
  'XAF',
  'XOF',
  'XPF'
] as const;

export const MIN_AMOUNT_CURRENCIES = [
  'USD',
  'AED',
  'AUD',
  'BGN',
  'BRL',
  'CAD',
  'CHF',
  'CZK',
  'DKK',
  'EUR',
  'GBP',
  'HKD',
  'HUF',
  'INR',
  'JPY',
  'MXN',
  'MYR',
  'NOK',
  'NZD',
  'PLN',
  'RON',
  'SEK',
  'SGD',
  'THB'
] as const;

export const MAX_AMOUNT_CURRENCIES = [
  'IDR',
  'INR',
  'LBP',
  'COP',
  'HUF',
  'JPY'
] as const;
